import * as React from 'react';

function SvgTrash2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M14 3a.702.702 0 01-.037.225l-1.684 10.104A2 2 0 0110.305 15H5.694a2 2 0 01-1.973-1.671L2.037 3.225A.703.703 0 012 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 00.986.836h4.612a1 1 0 00.986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z' />
		</svg>
	);
}

export default SvgTrash2;
